import React from 'react';
import { FaFacebookF, FaInstagram, FaTiktok } from 'react-icons/fa';

const SocialLinks = ({ containerClass }) => {
  return (
    <div className={containerClass}>
      <a href="https://facebook.com/BurgerBarnBearLake" target="_blank" rel="noopener noreferrer">
        <FaFacebookF size={34} />
      </a>
      <a href="https://www.instagram.com/burgerbarnbearlake" target="_blank" rel="noopener noreferrer">
        <FaInstagram size={34} />
      </a>
      <a href="https://www.tiktok.com/@theburgerbarnbearlake" target="_blank" rel="noopener noreferrer">
        <FaTiktok size={34} />
      </a>
    </div>
  );
};

export default SocialLinks;
